import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { InfoIcon } from "lucide-react";

interface FeatureInDevelopmentProps {
  title: string;
  description: string;
  features?: string[];
}

export function FeatureInDevelopment({
  title,
  description,
  features,
}: FeatureInDevelopmentProps) {
  return (
    <Card className="card-navy-glass border-navy-500">
      <CardContent className="pt-6">
        <div className="p-4 border border-navy-500 rounded-md bg-accent-primary/5 flex items-start gap-3">
          <InfoIcon className="h-5 w-5 text-accent-primary mt-0.5 flex-shrink-0" />
          <div className="text-sm flex-1">
            <div className="flex items-start justify-between gap-4 mb-2">
              <p className="font-medium text-foreground">{title}</p>
              <Badge className="bg-yellow-500/10 text-yellow-500 border-yellow-500 px-2 py-0.5 text-xs">
                Em Desenvolvimento
              </Badge>
            </div>
            <p className="text-muted-foreground mb-3">{description}</p>
            {features && features.length > 0 && (
              <div className="mt-3 pt-3 border-t border-navy-500">
                <p className="text-xs font-medium text-muted-foreground mb-2">
                  Funcionalidades planejadas:
                </p>
                <ul className="space-y-1">
                  {features.map((feature, index) => (
                    <li
                      key={index}
                      className="text-xs text-muted-foreground flex items-center gap-2"
                    >
                      <span className="w-1 h-1 rounded-full bg-accent-primary" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
